import { ResponsivePie } from "@nivo/pie";
import api from "@/components/customAxios/Axios";
import { useToast } from "@/components/toast";
import { useLoader } from "@/context/loaderContext";
import { useEffect, useState } from "react";

type dataType = {
	assessment_used_count: string;
	cv_used_count: string;
};
const FreeTrailInsights = () => {
	const [data, setData] = useState<dataType>();
	const [pieChartData, setPieChartData] = useState(() => {
		return [
			{
				id: "CVs Used",
				label: "CVs Used",
				value: 0,
				color: "",
			},
			{
				id: "CVs Left",
				label: "CVs Left",
				value: 0,
				color: "",
			},
			{
				id: "Assessments Used",
				label: "Assessments Used",
				value: 0,
				color: "",
			},
			{
				id: "Assessments Left",
				label: "Assessments Left",
				value: 0,
				color: "",
			},
		];
	});

	const { setLoading } = useLoader();
	const toast = useToast();

	const getQuickData = async () => {
		try {
			setLoading(true);
			const response = await api.get("/trial_dashboard");
			setData(response.data);
		} catch (err: any) {
			setLoading(false);
			toast.error({
				type: "background",
				duration: 5000,
				status: "error",
				title: "Error Fetching Analytics Details",
				description: err.response?.data?.error || err.response?.data?.message || "Failed to fetch analytics details. Please try again.",
				open: true,
			});
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getQuickData();
	}, []);

	useEffect(() => {
		if (!data) return;
		console.log("test   ", data);
		const cvUsed = parseInt(data?.cv_used_count.split("/")[0] || "0", 10);
		const cvTotal = parseInt(data?.cv_used_count.split("/")[1] || "0", 10);
		const assessmentUsed = parseInt(
			data?.assessment_used_count.split("/")[0] || "0",
			10
		);
		const assessmentTotal = parseInt(
			data?.assessment_used_count.split("/")[1] || "0",
			10
		);
		setPieChartData([
			{
				id: "CVs Used",
				label: "CVs Used",
				value: cvUsed,
				color: "#6EE7B7",
			},
			{
				id: "CVs Left",
				label: "CVs Left",
				value: cvTotal - cvUsed,
				color: "#E5E7EB",
			},
			{
				id: "Assessments Used",
				label: "Assessments Used",
				value: assessmentUsed,
				color: "#93C5FD",
			},
			{
				id: "Assessments Left",
				label: "Assessments Left",
				value: assessmentTotal - assessmentUsed,
				color: "#E5E7EB",
			},
		]);
	}, [data]);

	return (
		<>
			<div className=" bg-white rounded-xl p-6  w-full">
				<h2 className="text-lg font-semibold mb-6">Free Trial Insights</h2>
				{/* Chart container */}
				<div className="flex flex-wrap items-center justify-around gap-10 w-full">
					<div className="relative size-64">
						{/* Resume Doughnut */}
						<div className="absolute inset-0 pointer-events-none">
							<div className="pointer-events-auto w-full h-full">
								<ResponsivePie
									data={pieChartData.slice(1)}
									innerRadius={0.8}
									padAngle={0}
									cornerRadius={3}
									enableArcLabels={false}
									enableArcLinkLabels={false}
									colors={(d) => d.data.color}
									startAngle={-135}
									endAngle={225}
									sortByValue={true}
									margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
									animate={false}
								/>
							</div>
						</div>

						{/* Assessment Doughnut */}
						<div className="absolute inset-10 pointer-events-none">
							<div className="pointer-events-auto w-full h-full">
								<ResponsivePie
									data={pieChartData.slice(0, 2)}
									innerRadius={0.7}
									padAngle={0}
									cornerRadius={3}
									enableArcLabels={false}
									enableArcLinkLabels={false}
									colors={(d) => d.data.color}
									startAngle={-135}
									endAngle={225}
									sortByValue={true}
									margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
									animate={false}
								/>
							</div>
						</div>

						{/* User Doughnut */}
						<div className="absolute inset-20 pointer-events-none">
							<div className="pointer-events-auto w-full h-full">
								<ResponsivePie
									data={pieChartData.slice(4, 6)}
									innerRadius={0.6}
									padAngle={0}
									cornerRadius={3}
									enableArcLabels={false}
									enableArcLinkLabels={false}
									colors={(d) => d.data.color}
									startAngle={-135}
									endAngle={225}
									sortByValue={true}
									margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
									animate={true}
								/>
							</div>
						</div>
					</div>

					{/* Legend */}
					<div className="text-sm space-y-3">
						<div className="flex items-center gap-2">
							<span className="w-3 h-3 bg-green-300 rounded-full"></span>
							Resume Screening {" " + data?.cv_used_count}
						</div>
						<div className="flex items-center gap-2">
							<span className="w-3 h-3 bg-blue-300 rounded-full"></span>
							Assessments {" " + data?.assessment_used_count}
						</div>
					</div>
				</div>

			</div>
		</>
	);
};

export default FreeTrailInsights;
